import React, { useEffect } from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import PostCalculationMain from "./recovery-calculator/post-calculations/PostCalculationMain";
import { isMobile } from "react-device-detect";
import MobileMessage from "../components/mobile-message/MobileMessage";
import { sumOFBills } from "./sumOfBillsCalculator";
import { UOF_CONSTANT } from "./uof_constant";
import { useForceUpdate } from "./useForceUpdate";
import { utilityArray } from "./utilities";
import { ThemeProvider } from "@material-ui/styles";
import { theme } from "../styles/theme";

export const CalculatorContext = React.createContext({});

export default function App() {
  const [calculatorTenants, setCalculatorTenants] = React.useState([
    '', '', '', '', '', '',
  ]);

  const [calculatorUtilities, setCalculatorUtilities] = React.useState({
    Water: {
      title: "Water",
      BTV: 0,
      daysLived: 30,
      proRataFactorPercent: 100,
      utilityPerTenant: [0, 0, 0, 0, 0, 0],
      OFSum: 0,
      CAD: 5,
      GWD: 5,
      ATP: 0,
      isEnabled: false,
    },
    "Hot water": {
      title: "Hot water",
      BTV: 0,
      daysLived: 30,
      proRataFactorPercent: 100,
      utilityPerTenant: [0, 0, 0, 0, 0, 0],
      OFSum: 0,
      CAD: 5,
      GWD: 5,
      ATP: 0,
      isEnabled: false,
    },
    Trash: {
      title: "Trash",
      BTV: 0,
      daysLived: 30,
      proRataFactorPercent: 100,
      utilityPerTenant: [0, 0, 0, 0, 0, 0],
      OFSum: 0,
      CAD: 5,
      GWD: 5,
      ATP: 0,
      isEnabled: false,
    },
    Sewer: {
      title: "Sewer",
      BTV: 0,
      daysLived: 30,
      proRataFactorPercent: 100,
      utilityPerTenant: [0, 0, 0, 0, 0, 0],
      OFSum: 0,
      CAD: 5,
      GWD: 5,
      ATP: 0,
      isEnabled: false,
    },
  });

  const updateSumOfBills = (key, value, title) => {
    if (key === "BTV") {
      sumOFBills();
    } else {
    }
  };

  //calculates ATP:
  const updateATP = (utility) => {
    const { BTV, CAD, GWD } = utility;
    if (CAD <= 100 && GWD <= 100 && BTV <= 9000000) {
      utility.ATP = BTV - ((GWD + CAD) / 100) * BTV;
      setCalculatorUtilities({
        ...calculatorUtilities,
        [utility.title]: utility,
      });
    }
  };

  const forceUpdate = useForceUpdate();

  useEffect(
    function updateChargePerUnit() {
      const utilities = Object.values(calculatorUtilities);
      let OFPerTenant = [];

      // const { utilityPerTenant, ATP } = utility;

      utilities.forEach((utility) => {
        OFPerTenant = [];

        const { utilityPerTenant, ATP } = utility;

        for (let i = 0; i < utilityPerTenant.length; i++) {
          const numberOfUnits = calculatorTenants[i];
          const OF = UOF_CONSTANT[i] * numberOfUnits;
          OFPerTenant.push(OF);
        }

        const totalOF = OFPerTenant.reduce((acc, value) => {
          return acc + value;
        }, 0);

        const $OF = ATP / totalOF;

        for (let i = 0; i < utilityPerTenant.length; i++) {
          const chargePerunit = $OF * UOF_CONSTANT[i];
          utilityPerTenant[i] = chargePerunit;
        }

        if (!isFinite(utilityPerTenant[1])) {
          for (let i = 0; i < utilityPerTenant.length; i++) {
            utilityPerTenant[i] = 0;
          }
        }
        forceUpdate();
      });
    },
    [calculatorTenants, calculatorUtilities]
  );

  const contextValue = {
    resetClicked: () => {
      setCalculatorTenants(['', '', '', '', '', '']);

      const utilityObject = { ...calculatorUtilities };

      utilityArray.forEach((utilityInArray) => {
        utilityObject[utilityInArray].BTV = 0;
        utilityObject[utilityInArray].ATP = 0;
        utilityObject[utilityInArray].CAD = 5;
        utilityObject[utilityInArray].GWD = 5;
      });

      setCalculatorUtilities(utilityObject);
    },

    tenants: calculatorTenants,

    updateTenant: (index, value, utility) => {
      const newTenants = [...calculatorTenants];
      newTenants[index] = value;
      setCalculatorTenants(newTenants);
    },

    utilities: calculatorUtilities,

    updateUtilitySelection: (index, value, oldUtility) => {
      const objectToArray = Object.values(calculatorUtilities).map((utility) =>
        utility.title === oldUtility ? { ...utility, title: value } : utility
      );

      const result = objectToArray.reduce(function (map, obj) {
        map[obj.title] = obj;
        return map;
      }, {});

      setCalculatorUtilities(result);
    },

    updateUtilityCalculations: (key, value, title) => {
      const utility = { ...calculatorUtilities[title] };
      utility[key] = Number(value.replace("$", "").replace("%", ""));

      updateATP(utility);
      updateSumOfBills(key, value, title);
    },
    updateUtilities: (index, value) => {
      const hasValue = calculatorUtilities[value].isEnabled === false;

      if (hasValue) {
        const newList = { ...calculatorUtilities };
        newList[value].isEnabled = true;

        setCalculatorUtilities(newList);

        sumOFBills(calculatorUtilities);
      } else {
        const newList = { ...calculatorUtilities };
        newList[value].isEnabled = false;

        // updateUtilityCalculations("BTV", 0, value);
        newList[value].BTV = Number(0);
        newList[value].ATP = Number(0);
        //*** rerender the textfields of BTV, CAD & GD
        setCalculatorUtilities(newList);

        sumOFBills(newList);
      }
    },
  };

  return (
    <ThemeProvider theme={theme}>
      <CalculatorContext.Provider value={contextValue}>
        <BrowserRouter>
          <Switch>
            {isMobile && <Route exact path="/calculator" component={MobileMessage} />}
            {!isMobile && <Route exact path="/calculator" component={PostCalculationMain} />}
          </Switch>
        </BrowserRouter>
      </CalculatorContext.Provider>
    </ThemeProvider>
  );
}
